import { queryOptions, useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { deleteFile } from '../../services/objectStore/deleteFile'
import { listFiles } from '../../services/objectStore/listFiles'
import { uploadFiles } from '../../services/objectStore/uploadFiles'
import { queryKeys } from './queryKeys'

export const objectStoreFilesQueryOptions = (dir: string) =>
  queryOptions({
    queryKey: queryKeys.objectStoreFiles(dir),
    queryFn: ({ signal }) => listFiles({ dir, signal }),
  })

export const useObjectStoreFiles = (dir: string | undefined) =>
  useQuery({ ...objectStoreFilesQueryOptions(dir as string), enabled: !!dir })

// Both consumers (Report's generatePdf catch, which also covers html2pdf failures, and
// FileInput's dropzone snackbar) surface upload failures locally, so the global one would double up.
export const useUploadObjectStoreFiles = (dir: string | undefined) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (files: File[]) => uploadFiles({ dir: dir as string, files }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.objectStoreFiles(dir) }),
    meta: { suppressGlobalError: true },
  })
}

export const useDeleteObjectStoreFile = (dir: string | undefined) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (key: string) => deleteFile({ key }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.objectStoreFiles(dir) }),
  })
}
